// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TabSwitcher_wrapper__QKn0T","tabs":"TabSwitcher_tabs__A9_6I","tab":"TabSwitcher_tab__Gbgm1","active":"TabSwitcher_active__giUGS"};